import IcoMoon from "react-icomoon";
import iconSet from "../../Icon/selection.json";

const Icon = (props) => <IcoMoon iconSet={iconSet} {...props} />;

export default Icon;
